// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner__loader__UBmsk","load6":"Spinner__load6__3S2CE","round":"Spinner__round__2qdnM"};